// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"SY-hU","portrait":"_2XTI7","paragraph":"_2GaWV","list":"_3iK8q","listItem":"_2M3y2","underlined":"POXfG","greetings":"_25wws"};